"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A function that takes in a string and returns a capitalized string.
 * @param string
 * @returns a capitalized string
 */
const capitalize = (string) => `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`;
exports.default = capitalize;
//# sourceMappingURL=capitalize.js.map